import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);
	}

	init() {
		const item = this.el; // elemento raíz del módulo (contendrá el botón de imprimir)

		// Obtener company id desde data-empresa en el elemento raíz
		const dataEmpresa = item.getAttribute('data-empresa') || item.dataset.empresa || null;
		this.companyId = dataEmpresa ? parseInt(dataEmpresa, 10) : null;


		item.addEventListener('click', () => {
			// Construir el root del REST API de forma robusta y evitar duplicados de /wp-json
			const siteObj = (typeof art !== 'undefined') ? art : (window.ART_PDF || {});
			let restRoot = null;

			// 1. wpApiSettings.root es lo más confiable: WordPress lo inyecta automáticamente en el <head>
			//    e incluye subcarpetas/subdirectorios correctamente (ej: /investool/wp-json o /wp-json)
			if (window.wpApiSettings && wpApiSettings.root) {
				restRoot = wpApiSettings.root.replace(/\/$/, '');
				console.log('🟢 REST root from wpApiSettings:', restRoot);
			}
			// 2. Si no está disponible wpApiSettings, intentar con propiedades globales 'art'
			else if (siteObj.restUrl) {
				restRoot = siteObj.restUrl.replace(/\/$/, '');
				console.log('🟢 REST root from art.restUrl:', restRoot);
			}
			// 3. Fallback: construir URL relativa desde la ubicación actual del documento
			//    Esto funciona incluso si WordPress está en una subcarpeta
			else {
				// Extraer path del documento actual (ej: /investool/empresas/page/ o /empresas/)
				// y buscar /wp-json en el mismo nivel de directorios
				const currentPath = window.location.pathname.split('/').filter(p => p).slice(0, -1).join('/');
				const possiblePaths = [
					currentPath ? `/${currentPath}/wp-json` : '/wp-json',  // con subcarpeta si la hay
					'/wp-json'  // fallback directo en raíz
				];
				// Usar la primera ruta disponible o la más probable
				restRoot = possiblePaths[0];
				console.log('🟡 REST root from pathname heuristic:', restRoot);
			}

			const endpoint = `${restRoot}/art/v1/pdf/empresa`;

			
			
			
			if (!this.companyId) {
				console.error('Company ID no está definido.');
				return;
			}
			
			// Preparar payload
			const payload = {
				company_id: this.companyId,
				template: item.getAttribute('data-template') || (siteObj.template || 'ficha-default'),
				download: true
			};

			// Añadir idioma si está disponible (WPLM o WP locale inj.):
			if (siteObj.lang) {
				payload.lang = siteObj.lang; // ej. 'es'
			} else if (siteObj.locale) {
				payload.lang = siteObj.locale; // ej. 'es_ES'
			}
			console.log('🟣 Endpoint:', endpoint);
			console.log('🟣 Payload:', payload);

			// Headers: usar nonce si está disponible en el objeto global
			const headers = { 'Content-Type': 'application/json', 'Accept': 'application/pdf, application/json' };
			if (siteObj.nonce) {
				headers['X-WP-Nonce'] = siteObj.nonce;
			}

			// Credentials: usar same-origin si el endpoint apunta al mismo origen
			const endpointOrigin = (new URL(endpoint)).origin;
			const credentialsMode = (endpointOrigin === window.location.origin) ? 'same-origin' : 'include';

			// Hacer POST al endpoint y abrir el PDF devuelto
			// UI: marcar loading — overlay + cambios en el botón
			const originalText = item.textContent;
			item.classList.add('is-loading');
			if (item.tagName.toLowerCase() === 'button') {
				item.disabled = true;
				item.textContent = 'Generando...';
			}

			// Crear overlay global si no existe
			let pdfOverlay = document.getElementById('art-pdf-overlay');
			if (!pdfOverlay) {
				pdfOverlay = document.createElement('div');
				pdfOverlay.id = 'art-pdf-overlay';
				pdfOverlay.setAttribute('aria-hidden', 'true');
				// start hidden; we'll toggle display when showing/hiding to ensure it's visually removed
				pdfOverlay.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,0.45);z-index:99999;';
				const inner = document.createElement('div');
				inner.style.cssText = 'background:#fff;padding:18px 22px;border-radius:8px;display:flex;align-items:center;gap:12px;box-shadow:0 6px 18px rgba(0,0,0,0.35);';
				const spinner = document.createElement('div');
				spinner.style.cssText = 'width:36px;height:36px;border:4px solid #ddd;border-top-color:#3b82f6;border-radius:50%;animation:artPdfSpin 1s linear infinite;';
				const txt = document.createElement('div');
				txt.textContent = 'Generando PDF — por favor espera...';
				inner.appendChild(spinner);
				inner.appendChild(txt);
				pdfOverlay.appendChild(inner);
				document.body.appendChild(pdfOverlay);
				// Añadir keyframes dinámicos (si no existe)
				if (!document.getElementById('art-pdf-overlay-style')) {
					const style = document.createElement('style');
					style.id = 'art-pdf-overlay-style';
					style.textContent = `@keyframes artPdfSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`;
					document.head.appendChild(style);
				}
			}
			// show overlay
			pdfOverlay.setAttribute('aria-hidden', 'false');
			pdfOverlay.style.display = 'flex';
			document.documentElement.classList.add('art-pdf-generating');

			// Helper para ocultar overlay y limpiar estado visual
			const hideOverlay = () => {
				const pdfOverlayEl = document.getElementById('art-pdf-overlay');
				if (pdfOverlayEl) {
					pdfOverlayEl.setAttribute('aria-hidden', 'true');
					// also hide visually
					pdfOverlayEl.style.display = 'none';
				}
				document.documentElement.classList.remove('art-pdf-generating');
			};

			// Central restore UI helper: hides overlay, clears timeout and restores button state
			let overlayTimeoutId = null;
			const overlayTimeoutMs = parseInt(item.getAttribute('data-pdf-timeout'), 10) || (siteObj.pdfTimeout ? parseInt(siteObj.pdfTimeout, 10) : null) || 60000;
			const startOverlayTimeout = () => {
				overlayTimeoutId = setTimeout(() => {
					console.warn('PDF generation timeout: hiding overlay');
					restoreUI();
				}, overlayTimeoutMs);
			};
			const restoreUI = () => {
				hideOverlay();
				if (overlayTimeoutId) {
					clearTimeout(overlayTimeoutId);
					overlayTimeoutId = null;
				}
				item.classList.remove('is-loading');
				if (item.tagName.toLowerCase() === 'button') {
					item.disabled = false;
					item.textContent = originalText;
				}
			};

			// Start safety timeout
			startOverlayTimeout();
			try {
				fetch(endpoint, {
				method: 'POST',
				credentials: credentialsMode,
				headers: headers,
				body: JSON.stringify(payload)
			})
			.then(response => {
				// Loguear status y tipo para depuración rápida
				console.log('Fetch response status:', response.status);
				const contentType = response.headers.get('content-type') || '';
				console.log('Fetch response content-type:', contentType);
				// Ocultar overlay tan pronto como el servidor responde (ya se ha generado el PDF o la URL)
				hideOverlay();
				if (contentType.indexOf('application/pdf') !== -1) {
					// Respuesta directa con PDF -> abrir blob y pasar content-disposition
					const contentDisposition = response.headers.get('content-disposition') || null;
					return response.blob().then(blob => ({ ok: response.ok, pdfBlob: blob, contentDisposition }));
				}

				// Intentar parsear JSON (error o URL). Si no es JSON, devolver texto crudo y registrarlo.
				return response.text().then(text => {
					let data = null;
					try {
						data = text ? JSON.parse(text) : null;
					} catch (e) {
						console.error('Respuesta no-JSON recibida del endpoint:', response.status, text);
						// Mostrar alerta más informativa para 500s
						if (response.status >= 500) {
							alert('Error interno en el servidor (500). Revisa logs del servidor para más información.');
						}
						const isDebug = ((siteObj && siteObj.debug) || /(^|\.)dev\.|\blab\.|localhost/.test(window.location.hostname));
						// If server returned HTML and we're in debug, show part of it in the overlay for easier inspection
						if (isDebug && pdfOverlay && typeof text === 'string' && text.trim().length) {
							const inner = pdfOverlay.querySelector('div');
							// remove spinner children; replace with a small pre block showing first 2k chars
							while (inner.firstChild) { inner.removeChild(inner.firstChild); }
							const pre = document.createElement('pre');
							pre.style.cssText = 'max-width:80vw;max-height:60vh;overflow:auto;white-space:pre-wrap;background:#111;color:#fff;padding:10px;border-radius:6px;';
							pre.textContent = text.substring(0, 2000);
							inner.appendChild(pre);
							// Keep overlay visible until user closes it manually
							const closeBtn = document.createElement('button');
							closeBtn.textContent = 'Cerrar';
							closeBtn.style.cssText = 'display:block;margin-top:12px;background:#fff;color:#333;padding:6px 10px;border-radius:6px;border:0;cursor:pointer;';
							inner.appendChild(closeBtn);
							closeBtn.addEventListener('click', () => { hideOverlay(); });
						}
						return { ok: response.ok, status: response.status, raw: text };
					}
					return { ok: response.ok, status: response.status, data };
				});
			})
			.then(result => {
				// Restaurar UI
				item.classList.remove('is-loading');
				if (item.tagName.toLowerCase() === 'button') {
					item.disabled = false;
					item.textContent = originalText;
				}
				if (result.pdfBlob) {
					// Intentar obtener filename desde header Content-Disposition si existe
					let fileName = item.getAttribute('data-filename') || (siteObj.template || 'ficha') + '-' + Date.now() + '.pdf';
					if (result.contentDisposition) {
						const match = /filename\*=UTF-8''([^;\n\r]+)/i.exec(result.contentDisposition) || /filename="?([^";\n\r]+)"?/i.exec(result.contentDisposition);
						if (match && match[1]) {
							try {
								// filename* may be percent-encoded
								fileName = decodeURIComponent(match[1]);
							} catch (e) {
								fileName = match[1];
							}
						}
					}
					const url = URL.createObjectURL(result.pdfBlob);
					const a = document.createElement('a');
					a.href = url;
					a.download = fileName;
					document.body.appendChild(a);
					a.click();
					a.remove();
						URL.revokeObjectURL(url);
							restoreUI();
							return;
				}
				if (!result.ok) {
					console.error('Error generando PDF', result.status, result.data || result.raw);
					const errMsg = result.data && result.data.error ? result.data.error : (result.raw || 'Error al generar PDF');
					alert(errMsg);
					restoreUI();
					return;
				}

				const data = result.data;
				if (data && data.url) {
					restoreUI();
					window.open(data.url, '_blank');
				} else if (data && data.path) {
					restoreUI();
					alert('PDF generado: ' + data.path);
				} else {
					restoreUI();
					alert('PDF generado, pero no se recibió la URL.');
				}
			})
			.finally(() => {
				// Garantizar que el overlay y el estado UI quedan limpios
				restoreUI();
			}).catch(err => {
				// Restaurar UI en error
				// Use centralized restore
				restoreUI();
				console.error('Fetch error', err);
				alert('No se pudo generar el PDF. Revisa la consola.');
			});
			} catch (err) {
				// errores síncronos antes de que fetch devuelva una promesa
				restoreUI();
				console.error('Error sincronico al iniciar la petición fetch', err);
				alert('No se pudo iniciar la generación del PDF. Revisa la consola.');
			}
		});

		
	}
}